// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import EditingPresenceController from "./editing_presence_controller"
application.register("editing-presence", EditingPresenceController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import HeadingAnchorController from "./heading_anchor_controller"
application.register("heading-anchor", HeadingAnchorController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import RecentPagesController from "./recent_pages_controller"
application.register("recent-pages", RecentPagesController)

import ScrollOffsetController from "./scroll_offset_controller"
application.register("scroll-offset", ScrollOffsetController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import TocController from "./toc_controller"
application.register("toc", TocController)

import TokenFieldController from "./token_field_controller"
application.register("token-field", TokenFieldController)

import TreeController from "./tree_controller"
application.register("tree", TreeController)
